import {
  createContext,
  type ReactNode,
  useContext,
  useMemo,
  useState,
} from "react";

interface DispatchCenterScopeValue {
  dispatchCenterId: string | null;
  setDispatchCenterId: (dispatchCenterId: string | null) => void;
}

const DispatchCenterScopeContext =
  createContext<DispatchCenterScopeValue | null>(null);

export function DispatchCenterScopeProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [dispatchCenterId, setDispatchCenterId] = useState<string | null>(null);

  const value = useMemo(
    () => ({ dispatchCenterId, setDispatchCenterId }),
    [dispatchCenterId]
  );

  return (
    <DispatchCenterScopeContext.Provider value={value}>
      {children}
    </DispatchCenterScopeContext.Provider>
  );
}

export function useDispatchCenterScope(): DispatchCenterScopeValue {
  const value = useContext(DispatchCenterScopeContext);
  if (!value) {
    throw new Error(
      "useDispatchCenterScope must be used within DispatchCenterScopeProvider"
    );
  }
  return value;
}

export function useOptionalDispatchCenterScope(): DispatchCenterScopeValue {
  return (
    useContext(DispatchCenterScopeContext) ?? {
      dispatchCenterId: null,
      setDispatchCenterId: () => undefined,
    }
  );
}
